import type { User as FirebaseUser } from 'firebase/auth';
import { authService } from '../../services/auth/authService';
import type { SaveUserResult } from '../../entities/auth/authResult';

/**
 * SaveUserUseCase
 *
 * Creates or updates the application's user record for the given
 * Firebase user. Mirrors Flutter's
 * `AppAuthenticationService.saveUser`
 * (lib/services/app_authentication_service.dart:509), invoked from
 * `_login` (lib/presentation/screens/login/login_screen.dart:157) as the
 * second step of the login flow after the Firebase popup completes.
 */
export class SaveUserUseCase {
    async execute(firebaseUser: FirebaseUser): Promise<SaveUserResult> {
        return await authService.saveUser(firebaseUser);
    }
}

export const saveUserUseCase = new SaveUserUseCase();
